const Star = ({ size=15, color="#12a87a", ...props }) => (
    <svg
        width={size + 4}
        height={size}
        viewBox="5 0 20 24"
        fill="none"
        {...props}
    >
        <path
            d="M12 2L14.9 8.6L22 9.3L16.5 14.2L18.2 21L12 17.5L5.8 21L7.5 14.2L2 9.3L9.1 8.6L12 2Z"
            stroke={color}
            strokeWidth="2"
            fill="none"
        />
    </svg>
);

export default Star;
